import React, { useContext } from 'react';
import PricingContext from '../../../context/pricing';
import { startFree } from '../../../utils/pricing';
import { StyledHeader, StyledSubHeaderText, StyledText } from './styles';
import Tabs from '../Tabs';

const Header = () => {
  const { isFullPricing } = useContext(PricingContext);
  return (
    <StyledHeader>
      {isFullPricing && (
        <div className="row row--large">
          <h1>Send email at (your) scale.</h1>
          <StyledSubHeaderText>
            Get started for free with 100 emails/day forever. No credit card
            required.
          </StyledSubHeaderText>
          <button
            type="button"
            onClick={startFree}
            title="Get Started for Free"
            className="btn btn--primary"
            data-gtm-track="true"
            data-gtm-event-type="cta"
          >
            Start for free
          </button>
          <StyledText>
            {/* For custom plans,{' '}
            <a
              href="/contact-us-form/"
              title="Contact sales"
              className="arrow-link"
            >
              Contact Us
            </a> */}
          </StyledText>
        </div>
      )}
      <div className="row row--large">
        <Tabs />
      </div>
    </StyledHeader>
  );
};

export default Header;
